<div class="keen-slider__slide salon-slide">
  <article
    [routerLink]="['/customer/salon', salon?.salon_id]"
    class="salon-card"
  >
    <div class="salon-card__motion">
      <div class="salon-card__media-wrap">
        <div class="salon-card__media">
          <img
            class="salon-card__image"
            [src]="assetUrl + 'img/mock-salon1.png'"
            loading="lazy"
            alt="{{ salon?.name || 'Salon' }}"
          />
        </div>

        @if (hasLeftIcon) {
          <div class="salon-card__badge-wrap">
            <span class="salon-card__badge-cap"></span>
            <span class="salon-card__badge"> Popular </span>
          </div>
        }

        <button
          class="salon-card__fav-btn"
          type="button"
          (click)="AddToFav($event, salon?.salon_id)"
          title="Add to favorite"
          [disabled]="isLoading"
        >
          <img
            [src]="assetUrl + 'icons/favorite.svg'"
            *ngIf="!salon?.is_favorite; else redHeart"
            alt="Add to favorites"
          />
          <ng-template #redHeart>
            <img
              [src]="assetUrl + 'icons/favorite-red.svg'"
              alt="Remove from favorites"
            />
          </ng-template>
        </button>
      </div>

      <div class="salon-card__body">
        <h4 class="salon-card__title">
          {{ salon?.name || "Soho Studio Plus" }}
        </h4>

        <div class="salon-card__meta">
          <img
            [src]="assetUrl + 'icons/star.svg'"
            class="salon-card__meta-icon"
          />
          <span>4.7 • 188 Reviews</span>
        </div>

        <div class="salon-card__meta salon-card__meta--muted">
          <img
            [src]="assetUrl + 'icons/marker.svg'"
            class="salon-card__meta-icon"
          />
          <span class="salon-card__location"
            >1.2 km • {{ getSalonLocation() }}</span
          >
        </div>

        <div class="salon-card__tags">
          @for (service of getDisplayServices(); track service) {
            <glo-tag
              [text]="service"
              state="default"
              [showIcon]="false"
            ></glo-tag>
          }
        </div>
      </div>
    </div>
  </article>
</div>
